import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import i18n from "./i18n/config";
import { I18nextProvider } from "react-i18next";
import { HashRouter } from "react-router-dom";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container missing in index.html");
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <HashRouter>
        <App />
      </HashRouter>
    </I18nextProvider>
  </React.StrictMode>
);
